<script setup>
import { VideoStore } from '@/front/stores/video_store.js'
const videoStore = VideoStore()
import { finishAudio } from '@/front/composables/ClickComposer.js'
import AudioPlayer from '@/front/components/AudioPlayer.vue';
import Button from 'primevue/button';
import { Cancel01Icon } from 'hugeicons-vue';
import { PlayerStore } from '@/front/stores/player_store.js';
const playerStore = PlayerStore();
import SpeakerAnimation from '@/front/components/SpeakerAnimation.vue'
// Have to calcualte aspect ratio to pin layer to actual video
// LATER handle cover mode

const handleEnded = () => {
  log.info(3,"AudioLayer handleEnded")
  finishAudio()
  // finishClip()
}

const getVolume = computed(() => {
  return playerStore.originalVolume
})

const canSkip = computed(() => {
  return videoStore.video.can_skip_clips || videoStore.video.manage
})

</script>

<template>
  <div id="clip-layer" class="absolute top-0 left-0 w-full h-full overflow-y-scroll no-scrollbar flex flex-col justify-center items-center">
    <div class="bg-[var(--user-theme-color)] w-10 h-10 overflow-hidden absolute top-0 left-[50%] translate-x-[-50%]">
      <SpeakerAnimation />
    </div>
    <AudioPlayer :controls="false" @ended="handleEnded" class="opacity-0" :volume="getVolume"/>
    <Button v-if="canSkip" @click.stop="finishAudio" class="!absolute top-1 right-1 !bg-[var(--user-theme-color)] !text-white" rounded size="small">
      <Cancel01Icon :size="20" class="font-bold text-white" />
    </Button>
  </div>
</template>

<style>
</style>
